import { createSlice } from '@reduxjs/toolkit'
import { StateData } from './state-model'

const initialState: StateData = {
  filter: {
    name: '',
    code: '',
    fromCountryDevision: '',
    toCountryDevision: '',
    isActive: true,
 
  },
  geoData: {},
  areaType:null,
  selectedZone:{},
  addZone: false,
}
const CustomGeoReducer = createSlice({
  initialState: initialState,
  name: 'customGeo',
  reducers: {
    activeAddZone:(state,action)=>{
      state.addZone = action.payload
    },
    fetchGeoList: (state, action) => {
       
      state.geoData = action.payload
    },
    clearGeoList: (state) => {
      state.geoData = {}
      
    },
    setFilter: (state, action) => {
      state.filter = action.payload
    },
    setAreaType: (state, action) => {
      state.areaType = action.payload
    },
    setSelectedZone: (state, action) => {
      state.selectedZone = action.payload
    },
  },
})
export const { fetchGeoList, clearGeoList, setFilter,setAreaType,setSelectedZone,activeAddZone } =
  CustomGeoReducer.actions
export default CustomGeoReducer.reducer
